import { connectHits } from "react-instantsearch-dom"
import { useRegisterActions, Action } from "kbar"
import { extractTitleFromHit } from "../utils/titleExtraction"
import { saveToRecentHistory } from "../utils/storage"
import { REPO_CONFIG } from "../constants"
import type { RepoName } from "../types"

interface AlgoliaHitsToActionsProps {
  indexName?: RepoName
}

const AlgoliaHitsToActionsComponent = connectHits<AlgoliaHitsToActionsProps>(
  ({ hits, indexName }) => {
    const actions: Action[] = hits.map((hit: any) => {
      const name = extractTitleFromHit(hit)

      // Determine section name based on whether we're in cross-repo or scoped search
      const sectionName = indexName
        ? REPO_CONFIG[indexName].displayName
        : "Documentation"

      return {
        id: `search-${hit.objectID}`,
        name,
        subtitle: `${hit.slug}${
          hit.body ? ` • ${hit.body.substring(0, 100)}...` : ""
        }`,
        section: sectionName,
        keywords: `${name} ${hit.body || ""} ${hit.subheadings || ""}`,
        perform: () => {
          if (typeof window !== "undefined") {
            saveToRecentHistory(hit.slug, name)
            window.location.href = hit.slug
          }
        },
      }
    })

    useRegisterActions(actions, [hits])
    return null
  }
)

export { AlgoliaHitsToActionsComponent as AlgoliaHitsToActions }
